import { Ring } from "@uiball/loaders";

import { t } from "../../../../services";
import { colors, strCode } from "../../../../consts";

import { Paragraph2 } from "../../../../components";

import { DownloadingStepWrapper } from "./styled";

const DownloadingStep = () => {
  return (
    <DownloadingStepWrapper>
      <Ring color={colors.RAISIN_100} size={38} lineWeight={4} speed={2} />
      <Paragraph2>{t(strCode.DOWNLOADING_INFO)}</Paragraph2>
    </DownloadingStepWrapper>
  );
};

export default DownloadingStep;
